import React from 'react'

export default function NationalBudget() {
  return (
    <div>NationalBudget</div>
  )
}
